export default "__VITE_ASSET__Bir377wb__"